export const castMembers = [
  {
    id: "cast-01",
    name: "韩志旼",
    role: "尹秀雅",
    roleType: "女主角 · 小姨子",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20an%20elegant%20korean%20actress%20in%20her%20early%20thirties%20with%20gentle%20warm%20eyes%20and%20soft%20cream%20tone%20wardrobe%2C%20warm%20neutral%20studio%20background%2C%20soft%20cinematic%20lighting%2C%20korean%20drama%20cast%20portrait%2C%20high%20detail%2C%20subtle%20film%20grain&width=800&height=800&seq=cast-01-portrait&orientation=squarish",
    bio: "出道多年的人气女演员，以细腻自然的表演风格著称，擅长诠释内敛而坚韧的女性角色。",
    works: "《春夜的信》《妈妈的厨房》《海边来信》",
    character: "温柔善良又不失坚韧，在生活的琐碎里默默守护着一整个家。",
  },
  {
    id: "cast-02",
    name: "李到晛",
    role: "林承宇",
    roleType: "男主角 · 长兄",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20handsome%20korean%20actor%20in%20his%20mid%20thirties%20with%20a%20calm%20reserved%20expression%20and%20dark%20coat%2C%20warm%20neutral%20studio%20background%2C%20soft%20cinematic%20lighting%2C%20korean%20drama%20cast%20portrait%2C%20high%20detail%2C%20subtle%20film%20grain&width=800&height=800&seq=cast-02-portrait&orientation=squarish",
    bio: "实力派男演员，气质沉稳，凭借多部家庭剧中的“沉默长子”形象深入人心。",
    works: "《归途》《海边的父亲》《倒带人生》",
    character: "外表冷硬、内心柔软，用沉默的方式扛起整个家庭的责任。",
  },
  {
    id: "cast-03",
    name: "尹汝贞",
    role: "林外婆",
    roleType: "重要角色 · 外婆",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20kind%20elderly%20korean%20grandmother%20with%20silver%20hair%20and%20a%20warm%20gentle%20smile%20wearing%20a%20soft%20knit%20cardigan%2C%20warm%20neutral%20background%2C%20soft%20cinematic%20lighting%2C%20korean%20drama%20cast%20portrait%2C%20high%20detail%2C%20subtle%20film%20grain&width=800&height=800&seq=cast-03-portrait&orientation=squarish",
    bio: "德高望重的老戏骨，表演温润而有力量，每一个眼神都充满故事感。",
    works: "《旧屋》《母亲的院子》《金色年华》",
    character: "慈祥通透的老人，是维系整个家庭的温柔锚点。",
  },
  {
    id: "cast-04",
    name: "金裕贞",
    role: "尹智雅",
    roleType: "配角 · 姐姐（回忆线）",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20graceful%20korean%20actress%20with%20long%20dark%20hair%20and%20a%20faint%20melancholic%20smile%20wearing%20a%20light%20blouse%2C%20warm%20neutral%20background%2C%20soft%20cinematic%20lighting%2C%20korean%20drama%20cast%20portrait%2C%20high%20detail%2C%20subtle%20film%20grain&width=800&height=800&seq=cast-04-portrait&orientation=squarish",
    bio: "灵气十足的女演员，擅长演绎带着淡淡忧郁气质的角色，回忆线中的表演尤为动人。",
    works: "《纸上花园》《晚安，海边》《微光》",
    character: "秀雅的姐姐，剧中的回忆与遗憾，是故事情感的重要起点。",
  },
  {
    id: "cast-05",
    name: "朴叙俊",
    role: "姜民载",
    roleType: "配角 · 主治医师",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20clean%20cut%20korean%20male%20actor%20in%20a%20light%20blue%20shirt%20with%20a%20friendly%20warm%20smile%2C%20warm%20neutral%20background%2C%20soft%20cinematic%20lighting%2C%20korean%20drama%20cast%20portrait%2C%20high%20detail%2C%20subtle%20film%20grain&width=800&height=800&seq=cast-05-portrait&orientation=squarish",
    bio: "阳光型男演员，出演过多部都市情感剧，是观众心中的“治愈系暖男”。",
    works: "《急诊室的一天》《我们的夏天》《逆光》",
    character: "医院里的主治医师，专业而体贴，是故事里的一束暖光。",
  },
  {
    id: "cast-06",
    name: "张娜拉",
    role: "吴美兰",
    roleType: "配角 · 邻家婶婶",
    photo:
      "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20lively%20middle%20aged%20korean%20woman%20with%20short%20styled%20hair%20and%20a%20curious%20expression%20wearing%20a%20colorful%20blouse%2C%20warm%20neutral%20background%2C%20soft%20cinematic%20lighting%2C%20korean%20drama%20cast%20portrait%2C%20high%20detail%2C%20subtle%20film%20grain&width=800&height=800&seq=cast-06-portrait&orientation=squarish",
    bio: "喜剧与正剧俱佳的演员，塑造的市井小人物生动鲜活，令人又气又笑。",
    works: "《巷子口的女人》《我们楼下》《热闹人家》",
    character: "爱说闲话却刀子嘴豆腐心的邻家婶婶，是流言的源头也是最后的帮手。",
  },
];

export default castMembers;